module.exports = __webpack_public_path__ + "img/6_dice[2].db9ea0bc.png";